import React from "react"
import PropTypes from "prop-types"
import { numberFormatter } from "../../../utils/numbers.utils"

const DetailedEstimationLabelTooltip = ({
  description,
  remainingSprints,
  remainingUserStories,
}) => {
  if (!description) {
    return null
  }
  return (
    <div>
      <span>{description}</span>
      {remainingSprints || remainingUserStories ?
        <>
          <br />
          <table className="w-full mt-2">
            <tbody className="w-full">
              {remainingSprints && (
                <tr className="w-full">
                  <td className="text-left">Sprints</td>
                  <td className="text-right">
                    ~{numberFormatter(remainingSprints)}
                  </td>
                </tr>
              )}
              {remainingUserStories && (
                <tr className="w-full">
                  <td className="text-left">Historias</td>
                  <td className="text-right">{remainingUserStories}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      : null}
    </div>
  )
}

export default DetailedEstimationLabelTooltip

DetailedEstimationLabelTooltip.propTypes = {
  description: PropTypes.string,
  remainingSprints: PropTypes.number,
  remainingUserStories: PropTypes.number,
}
